import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { downloadEmployeeData } from "../../api/dataExport";
import { TILE_3D, tileBtn } from "./actionTile";

// تصدير كل بيانات الموظف (GDPR) للموارد البشرية.
export const EmployeeDataExportButton = ({ userId }) => {
  const { t, i18n } = useTranslation();
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      await downloadEmployeeData(userId, i18n.language);
      toast.success(t("dataExport.done"));
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button className={tileBtn("bg-amber-500")} style={TILE_3D} data-testid="employee-data-export-btn" disabled={busy} onClick={run}>
      {busy ? t("dataExport.busy") : t("dataExport.employeeAction")}
    </button>
  );
};
